import { render, staticRenderFns } from "./StandardInput.vue?vue&type=template&id=5f1af3ea&scoped=true&"
import script from "./StandardInput.vue?vue&type=script&lang=js&"
export * from "./StandardInput.vue?vue&type=script&lang=js&"
import style0 from "./StandardInput.vue?vue&type=style&index=0&id=5f1af3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1af3ea",
  null
  
)

export default component.exports